import React from 'react';
import moment from 'moment';

import { getBatchItems } from '../../queries/Queries';
import QueryDataTable from '../../components/QueryDataTable/QueryDataTable';

const BillingLogsView = () => {
  const columns = [
    {
      dataField: 'status',
      text: 'Status',
      headerStyle: { width: '80px' },
      style: { textAlign: 'left' },
    },
    {
      dataField: 'message',
      text: 'Message',
      style: { textAlign: 'left' },
    },
    {
      dataField: 'data',
      text: 'Data',
      formatter: (cell) => {
        try {
          const data = JSON.parse(cell);
          return (
            <pre
              style={{
                whiteSpace: 'pre',
                overflowX: 'auto',
                maxWidth: '100%',
                textAlign: 'left',
              }}
            >
              {JSON.stringify(data, null, 2)}
            </pre>
          );
        } catch (e) {
          return cell;
        }
      },
      csvformatter: (cell) => {
        // strip quotes from JSON for CSV export
        try {
          const data = JSON.parse(cell);
          return JSON.stringify(data).replace(/"/g, '');
        } catch (e) {
          return String(cell).replace(/"/g, '');
        }
      },
    },
    {
      dataField: 'created',
      text: 'Created',
      sort: true,
      formatter: (cell) => moment(cell).format('DD/MM/YYYY HH:mm:ss'),
      headerStyle: { width: '160px' },
    },
  ];

  const buildWhereClause = (filters) => {
    let whereClause = "status == 'PF'";

    if (filters.search) {
      whereClause += ` and (data == '*${filters.search}*' or message == '*${filters.search}*')`;
    }

    if (filters.startDate && filters.endDate) {
      const dateFilter = `created >= '${filters.startDate.toISOString()}' and created <= '${filters.endDate.toISOString()}'`;
      whereClause += ` and ${dateFilter}`;
    }

    return whereClause;
  };

  return (
    <QueryDataTable
      title='Billing Logs'
      query={getBatchItems}
      columns={columns}
      defaultSort={{ field: 'created', order: 'desc' }}
      pageSizes={[10, 20, 50]}
      filters={[
        {
          type: 'text',
          name: 'search',
          placeholder: 'Search in data or message...',
          colSize: 8,
          defaultValues: '',
          useDebounce: true,
        },
        {
          type: 'dateRange',
          name: 'dateRange',
          startDateField: 'startDate',
          endDateField: 'endDate',
          colSize: 4,
          defaultValues: {
            startDate: moment().subtract(1, 'month').startOf('day'),
            endDate: moment().startOf('day'),
          },
        },
      ]}
      buildWhereClause={buildWhereClause}
      queryName='BatchItem'
      enableExport={true}
    />
  );
};

export default BillingLogsView;
